import { render, staticRenderFns } from "./MovimentacaoProduto.vue?vue&type=template&id=bbcf77c8&scoped=true&"
import script from "./MovimentacaoProduto.vue?vue&type=script&lang=js&"
export * from "./MovimentacaoProduto.vue?vue&type=script&lang=js&"
import style0 from "./MovimentacaoProduto.vue?vue&type=style&index=0&id=bbcf77c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf77c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
